import { useEffect, useRef } from "react";

/**
 * The keyboard-shortcut sheet behind `?`.
 *
 * Uses the design's `.scrim` + `.modal` + `.kgrid` markup, which mail.css
 * already styles — this is the screen those rules were written for.
 */
const GROUPS: { title: string; keys: [string, string][] }[] = [
  {
    title: "Move around",
    keys: [
      ["j  /  ↓", "Next message"],
      ["k  /  ↑", "Previous message"],
      ["Enter", "Open"],
      ["g then i", "Go to Inbox"],
      ["g then s", "Go to Sent"],
      ["g then d", "Go to Drafts"],
      ["g then c", "Go to Calendar"],
      ["g then p", "Go to People"],
      ["/", "Search"],
    ],
  },
  {
    title: "Act on a message",
    keys: [
      ["e", "Archive"],
      ["#", "Delete"],
      ["!", "Report spam"],
      ["u", "Mark unread"],
      ["s", "Star"],
      ["x", "Select"],
      ["r", "Reply"],
      ["a", "Reply all"],
      ["f", "Forward"],
    ],
  },
  {
    title: "Everything else",
    keys: [
      ["c", "Compose"],
      ["⌘/Ctrl + Enter", "Send"],
      ["Esc", "Close"],
      ["?", "This list"],
    ],
  },
];

export function Shortcuts({ onClose }: { onClose: () => void }) {
  const close = useRef<HTMLButtonElement>(null);

  // Focus moves into the dialog so the sheet is reachable and dismissible from
  // the keyboard — it would be a poor joke for the shortcuts sheet to be the
  // one thing you need a mouse for.
  useEffect(() => close.current?.focus(), []);

  return (
    <>
      <div className="scrim on" onClick={onClose} />
      <div
        className="modal on"
        role="dialog"
        aria-modal="true"
        aria-label="Keyboard shortcuts"
        data-screen-label="Shortcuts"
      >
        <h3>Keyboard shortcuts</h3>
        <p className="sub">Everything here works from the message list.</p>

        {GROUPS.map((group) => (
          <div key={group.title} style={{ marginBottom: 18 }}>
            <div className="mhead" style={{ padding: "0 0 6px" }}>{group.title}</div>
            <div className="kgrid">
              {group.keys.map(([key, label]) => (
                <div className="krow" key={key}>
                  <span>{label}</span>
                  <kbd>{key}</kbd>
                </div>
              ))}
            </div>
          </div>
        ))}

        <button ref={close} className="pill" onClick={onClose}>Close</button>
      </div>
    </>
  );
}
